document.addEventListener('DOMContentLoaded', function () {
    const labelMessage = document.querySelector('.rale-message');
    const lang = (document.documentElement.lang || '').toLowerCase();
    const baseLang = lang.split('-')[0];
    const termsLinks = {
        fr: 'https://solferino-paris.com/pages/conditions-generales-de-vente',
        en: 'https://solferino-paris.com/en/pages/terms-of-sale',
        de: 'https://solferino-paris.com/de/pages/conditions-generales-de-vente',
        es: 'https://solferino-paris.com/es/pages/conditions-generales-de-vente',
        it: 'https://solferino-paris.com/it/pages/conditions-generales-de-vente',
        ru: 'https://solferino-paris.com/ru/pages/conditions-generales-de-vente',
        ja: 'https://solferino-paris.com/ja/pages/conditions-generales-de-vente',
        zh: 'https://solferino-paris.com/zh/pages/conditions-generales-de-vente'
    };

    const newTabLabel = {
        fr: '(ouvre dans un nouvel onglet)',
        en: '(opens in new tab)',
        es: '(abre en una nueva pestaña)',
        it: '(si apre in una nuova scheda)',
        de: '(öffnet in einem neuen Tab)',
        ru: '(открывается в новой вкладке)',
        ja: '(新しいタブで開きます)',
        zh: '(在新标签页中打开)'
    };
    const srLabel = newTabLabel[baseLang] || newTabLabel.en;
    const srSpan = `<span class="sr-only"> ${srLabel}</span>`;

    if (baseLang === 'fr') {
        labelMessage.innerHTML = `Je confirme avoir lu et accepté les <a href="${termsLinks.fr}" target="_blank" rel="noopener noreferrer" class="rale-link">Conditions générales de vente.${srSpan}</a>`;
        return;
    }

    const termsLink = termsLinks[baseLang] || termsLinks.en;
    const messages = {
        en: `I accept and aggree the <a href="${termsLinks.en}" target="_blank" rel="noopener noreferrer" class="rale-link">terms of sale.${srSpan}</a>`,
        es: `Confirmo haber leído y aceptado las <a href="${termsLinks.es}" target="_blank" rel="noopener noreferrer" class="rale-link">Condiciones generales de venta.${srSpan}</a>`,
        it: `Confermo di aver letto e accettato le <a href="${termsLinks.it}" target="_blank" rel="noopener noreferrer" class="rale-link">Condizioni generali di vendita.${srSpan}</a>`,
        de: `Ich bestätige, die <a href="${termsLinks.de}" target="_blank" rel="noopener noreferrer" class="rale-link">Allgemeinen Geschäftsbedingungen${srSpan}</a> gelesen und akzeptiert zu haben.`,
        ru: `Я подтверждаю, что прочитал(а) и принимаю <a href="${termsLinks.ru}" target="_blank" rel="noopener noreferrer" class="rale-link">Общие условия продажи.${srSpan}</a>`,
        ja: `私は<a href="${termsLinks.ja}" target="_blank" rel="noopener noreferrer" class="rale-link">利用規約（販売条件）${srSpan}</a>を読み、同意したことを確認します。`,
        zh: `我确认已阅读并接受<a href="${termsLinks.zh}" target="_blank" rel="noopener noreferrer" class="rale-link">销售通用条款。${srSpan}</a>`
    };

    if(labelMessage)
    labelMessage.innerHTML = messages[baseLang] || messages.en;

});

document.addEventListener('DOMContentLoaded', function() {

  // Exclure les images sur la fiche produit — gérées par l'animation CSS de product-perfume
  var images = Array.from(document.querySelectorAll('.ingredient-image')).filter(function(img) {
    return !img.closest('product-perfume');
  });
  if (!images.length) return;

  // Fallback si IntersectionObserver non supporté
  if (!('IntersectionObserver' in window)) {
    images.forEach(function(img) {
      img.style.transform = 'translate(-50%, -50%) scale(1)';
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // Double check pour Safari : isIntersecting ET intersectionRatio
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        entry.target.style.transform = 'translate(-50%, -50%) scale(1)';
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  });

  images.forEach(function(img) {
    observer.observe(img);
  });

});



